import { render, staticRenderFns } from "./detail-partial-delivery-truck.vue?vue&type=template&id=aef2acb8"
import script from "./detail-partial-delivery-truck.vue?vue&type=script&lang=js"
export * from "./detail-partial-delivery-truck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports